import { render, staticRenderFns } from "./HoldingsPage.vue?vue&type=template&id=0cb38f62&"
import script from "./HoldingsPage.vue?vue&type=script&lang=js&"
export * from "./HoldingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports